/**
 * Mirrors `MAX_INPUT_MESSAGE_LENGTH` in packages/api/src/agent/system-prompt.ts.
 * The server is the one that enforces it (a 413); this copy only exists so the
 * user is warned before they hit send. Keep the two in sync.
 */
export const MAX_ASSISTANT_INPUT_LENGTH = 2000;
